import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const ContentCard = styled.div<{ $expandWhenEmpty?: boolean }>`
  border: 1px solid #ebebeb;
  border-radius: 8px;
  background: #fff;
  overflow: visible;
  margin: 0 20px 20px;

  @media (max-width: 768px) {
    margin: 0 16px 16px;
  }

  ${({ $expandWhenEmpty }) =>
    $expandWhenEmpty &&
    css`
      min-height: 460px;
    `}
`;

export const FiltersSection = styled.div`
  position: relative;
  z-index: 2;
`;

export const LegacyToolbar = styled.div`
  display: none;
`;

export const TableArea = styled.div<{ $expandWhenEmpty?: boolean }>`
  padding: 0 0 12px;

  @media (min-width: 993px) {
    padding: 4px 0 12px;
  }

  ${({ $expandWhenEmpty }) =>
    $expandWhenEmpty &&
    css`
      min-height: 280px;
    `}
`;

export const PaginationWrap = styled.div`
  padding: 8px 12px 16px;

  @media (max-width: 768px) {
    padding: 8px 16px 16px;
    display: flex;
    justify-content: center;
  }
`;

export const SelectionBarWrap = styled.div`
  padding: 0 12px 4px;

  @media (max-width: 768px) {
    padding: 0 16px 8px;
  }
`;

export const MobileTableWrap = styled.div`
  display: none;
`;

export const TableWrap = styled.div<{ $showTour?: boolean }>`
  position: relative;

  ${({ $showTour }) =>
    $showTour &&
    css`
      z-index: 1000;
      background-color: #f5f5f5;
      padding: 2px;
      border-radius: 8px;
    `}
`;
